/* global swal angular */
import './style.less';

export default function($uibModalInstance, $log, ApiClass, license) {
  'ngInject';
  try {
    const vm = this;
    vm.$onInit = activate;

    vm.close = item => $uibModalInstance.close(item);

    vm.formData = angular.copy(license);

    vm.update = function() {
      vm.licenseUpdateBtn = true;
      vm.close(vm.formData);
      vm.licenseUpdateBtn = false;
    };

    function activate() {
      if (license.extension_date) vm.formData.extension_date = new Date(license.extension_date);
      if (license.cycle_date) vm.cycle_date = new Date(license.cycle_date).toISOString();

      vm.formData = angular.copy(license);
    }
  } catch (error) {
    $log.error(error);
    throw error;
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/editExtension/index.js